import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {TeamModel} from '../../../../models/api/teamModel';
import {VisualWorkspaceTeamData} from '../../../../models/api/visualWorkspaceModel';
import {AppState} from '../../../../store/appState';
import {
  computeVisualWorkspaceRecentlyViewedMap,
  TagModelMap,
} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceHelpers';
import {makeGetVisualWorkspaceVisualCustomViewsForTeam} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {TeamWorkspaceEditorCustomViews} from './teamWorkspaceEditorCustomViews';

/*
 * Props.
 */

interface TeamWorkspaceEditorCustomViewsContainerProps {
  team: TeamModel;
  teamData: VisualWorkspaceTeamData;
  teamCustomViewModelMap: TagModelMap;
}

/*
 * Selectors.
 */

function getVisualWorkspaceCustomViewsForTeam(
  _state: AppState,
  props: TeamWorkspaceEditorCustomViewsContainerProps,
) {
  return props.teamData.customViews;
}

function getTeamCustomViewModelMap(_state: AppState, props: TeamWorkspaceEditorCustomViewsContainerProps) {
  return props.teamCustomViewModelMap;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeamWorkspaceEditorCustomViewsContainerProps>()(() => ({
  visualCustomViews: makeGetVisualWorkspaceVisualCustomViewsForTeam(
    getVisualWorkspaceCustomViewsForTeam,
    getTeamCustomViewModelMap,
    false,
  ),
  visualWorkspaceCustomViews: getVisualWorkspaceCustomViewsForTeam,
}));

export const TeamWorkspaceEditorCustomViewsContainer = connect(
  mapStateToProps,
  null,
  (stateProps, dispatchProps, ownProps) => {
    const {visualWorkspaceCustomViews} = stateProps;
    const recentlyViewedMap = computeVisualWorkspaceRecentlyViewedMap(visualWorkspaceCustomViews);
    return {
      ...ownProps,
      ...stateProps,
      recentlyViewedMap,
    };
  },
)(TeamWorkspaceEditorCustomViews);
